"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var SharedWidgets_1 = require("../../SharedWidgets");
var DomUtil_1 = require("../../utils/DomUtil");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var FlyoutListMenuTextWidget_1 = require("../FlyoutListMenuTextWidget");
/**
 * Convenience widget which combines a `DropdownButton` widget with a `FlyoutListMenuWidget`, with proper a11y.
 */
// tslint:disable-next-line:max-line-length
exports.HierarchicalDropdownWidget = React.forwardRef(function (props, ref) {
    var buttonRef = props.buttonRef, menuId = props.menuId, menuItemInfos = props.menuItemInfos, maxHeight = props.maxHeight, onSelect = props.onSelect, dropdownProps = tslib_1.__rest(props, ["buttonRef", "menuId", "menuItemInfos", "maxHeight", "onSelect"]);
    var _a = React.useState(false), isOpen = _a[0], setOpen = _a[1];
    var DefaultMenuId = React.useState(DomUtil_1.generateId())[0];
    var closeFn = React.useRef(null);
    var buttonElement = React.useRef(null);
    var menuProps = {
        allowAutoPosition: true,
        anchorEl: buttonElement.current,
        id: menuId || DefaultMenuId,
        maxHeight: maxHeight,
        menuItemInfos: menuItemInfos,
        menuStyle: tslib_1.__assign({}, (isOpen && { minWidth: buttonElement.current.getBoundingClientRect().width })),
        onSelect: function (value) { onSelect(value); closeFn.current(); },
        requestCloseAll: closeFn.current,
        // tslint:disable-next-line:deprecation
        stackingRootId: props.stackingRootId,
        testId: props.testId,
        toggleEl: buttonElement.current,
        zIndex: props.zIndex,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(SharedWidgets_1.DropdownButton, tslib_1.__assign({ "aria-controls": menuProps.id, "aria-haspopup": 'menu' }, dropdownProps, { children: props.children || '', focusOnClose: true, onClose: function () { setOpen(false); closeFn.current = null; }, onOpen: function (doneFn) { closeFn.current = doneFn; setOpen(true); }, ref: function (dropdownRef) {
                ReactHelpers_1.assignRef(ref, dropdownRef);
                var dropdownElem = ReactDOM.findDOMNode(dropdownRef);
                buttonElement.current = dropdownElem ? dropdownElem.querySelector('[aria-haspopup]') : null;
                ReactHelpers_1.assignRef(buttonRef, buttonElement.current);
            } })),
        !props.disabled && isOpen && React.createElement(FlyoutListMenuTextWidget_1.FlyoutListMenuWidget, tslib_1.__assign({}, menuProps)));
});
exports.HierarchicalDropdownWidget.displayName = 'HierarchicalDropdownWidget';
//# sourceMappingURL=HierarchicalDropdownWidget.js.map